import logo from './logo.svg';
import './App.css';
import Maps from './Maps';
import { AiFillPlusCircle, AiFillMinusCircle, AiFillInstagram, AiOutlineGithub, AiOutlineArrowRight } from "react-icons/ai";
import { FaFacebook, FaLinkedin } from "react-icons/fa";

function App() {
  return (
    <div className="page-container">
      <Maps className="maps-container"></Maps>
      <div className='footer-container'>
        <p className='footer-update'>Updated on 23 May , 1.50am</p>
        <p className='footer-copyright'>© Built By Wayne Tay</p>
        <div className='footer'>
          <div className='footer-logo-div'>
            <a className='react-icon-btn button' href='https://www.instagram.com/wayne_twh96/'>
              <AiFillInstagram size={24} className='footer-logo'/>
            </a>
            <a className='react-icon-btn button' href='https://www.facebook.com/wayne.tay.904/'>
              <FaFacebook size={24} className='footer-logo'/>
            </a>
            <a className='react-icon-btn button' href='https://www.linkedin.com/in/wayne-tay-62857a72/'>
              <FaLinkedin size={24} className='footer-logo'/>
            </a>
            <a className='react-icon-btn button' href='https://github.com/wayne-wh'>
              <AiOutlineGithub size={24} className='footer-logo'/>
            </a>
          </div>
        </div>
      </div>
        <div className='title-container'>
          <h2 className='title-one'>Places visited by Covid-19 cases in Singapore</h2>
          <h4 className='title-two'>(Past 14 days)</h4>
        </div>
    </div>
  );
}

export default App;
